/**
 * iframe坐标转换和事件处理工具函数
 */

/**
 * 修正iframe内的坐标到主页面坐标
 * @param e 鼠标事件
 * @returns 修正后的坐标 { pageX, pageY, clientX, clientY }
 */
export const correctIframeCoordinates = (e: MouseEvent) => {
  // 检查事件是否来自iframe
  const isFromIframe = e.target && (e.target as Element).ownerDocument !== document;
  
  let pageX = e.pageX;
  let pageY = e.pageY;
  let clientX = e.clientX;
  let clientY = e.clientY;
  
  // 如果事件来自iframe，需要修正坐标
  if (isFromIframe) {
    // 获取事件来源的iframe元素
    const sourceIframe = Array.from(document.querySelectorAll('iframe')).find(iframe => 
      iframe.contentDocument === (e.target as Element).ownerDocument
    );
    
    if (sourceIframe) {
      const iframeRect = sourceIframe.getBoundingClientRect();
      // 将iframe内的坐标转换为主页面的坐标
      pageX = e.pageX + iframeRect.left;
      pageY = e.pageY + iframeRect.top;
      clientX = e.clientX + iframeRect.left;
      clientY = e.clientY + iframeRect.top;
    }
  }
  
  return { pageX, pageY, clientX, clientY };
};

/**
 * 为所有iframe添加事件监听器
 * @param eventType 事件类型
 * @param handler 事件处理函数
 */
export const addIframeEventListeners = (eventType: string, handler: EventListener) => {
  const iframes = document.querySelectorAll('iframe');
  iframes.forEach(iframe => {
    const iframeDoc = iframe.contentDocument;
    iframeDoc?.addEventListener(eventType, handler);
  });
};

/**
 * 从所有iframe移除事件监听器
 * @param eventType 事件类型
 * @param handler 事件处理函数
 */
export const removeIframeEventListeners = (eventType: string, handler: EventListener) => {
  const iframes = document.querySelectorAll('iframe');
  iframes.forEach(iframe => {
    const iframeDoc = iframe.contentDocument;
    iframeDoc?.removeEventListener(eventType, handler);
  });
};

/**
 * 检查事件是否来自iframe
 * @param e 鼠标事件
 * @returns 是否来自iframe
 */
export const isEventFromIframe = (e: MouseEvent): boolean => {
  return e.target && (e.target as Element).ownerDocument !== document;
};

/**
 * 获取事件来源的iframe元素
 * @param e 鼠标事件
 * @returns iframe元素或null
 */
export const getSourceIframe = (e: MouseEvent): HTMLIFrameElement | null => {
  if (!isEventFromIframe(e)) {
    return null;
  }
  
  return Array.from(document.querySelectorAll('iframe')).find(iframe => 
    iframe.contentDocument === (e.target as Element).ownerDocument
  ) || null;
};
